import React, { useState, useEffect, useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, LexicalEditor, COMMAND_PRIORITY_NORMAL } from 'lexical';
import {
  ACTIVATE_FORMAT_PAINTER_COMMAND,
  DEACTIVATE_FORMAT_PAINTER_COMMAND,
  FORMAT_PAINTER_STATE_UPDATE_COMMAND,
  FormatPainterState,
} from './FormatPainterCommands';

const PaintBrushIcon = () => <i className='format painter' />;

export function FormatPainterToolbarButton() {
  const [editor] = useLexicalComposerContext();
  const [isActive, setIsActive] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [canCopy, setCanCopy] = useState(false);

  // 插件状态
  useEffect(() => {
    return editor.registerCommand<FormatPainterState>(
      FORMAT_PAINTER_STATE_UPDATE_COMMAND,
      (payload) => {
        setIsActive(payload.isActive);
        setIsSticky(payload.isSticky);
        return true;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor]);

  // 选区状态
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection) && !selection.isCollapsed()) {
          setCanCopy(true);
        } else {
          setCanCopy(false);
        }
      });
    });
  }, [editor]);

  const handleClick = () => {
    if (isActive) {
      editor.dispatchCommand(DEACTIVATE_FORMAT_PAINTER_COMMAND, undefined);
    } else if (canCopy) {
      editor.dispatchCommand(ACTIVATE_FORMAT_PAINTER_COMMAND, { sticky: false });
    }
    // * !isActive and !canCopy 什么也不做
  };

  // 双击 保持激活
  const handleDoubleClick = () => {
    if (isActive && isSticky) {
      editor.dispatchCommand(DEACTIVATE_FORMAT_PAINTER_COMMAND, undefined);
    } else if (canCopy) {
      editor.dispatchCommand(ACTIVATE_FORMAT_PAINTER_COMMAND, { sticky: true });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      className={`toolbar-item spaced ${isActive ? 'active' : ''}`}
    //   title={isActive ? (isSticky ? 'Format Painter (Sticky)' : 'Format Painter (Active)') : 'Format Painter'}
      title={'格式刷'}
      aria-label={isActive ? (isSticky ? 'Deactivate Format Painter (Sticky)' : 'Deactivate Format Painter (Active)') : 'Activate Format Painter'}
      disabled={!isActive && !canCopy}
    >
      <PaintBrushIcon />
      {/* <span style={{wordBreak: 'keep-all'}}>格式刷</span> */}
    </button>
  );
}

{/* <button type='button'
className={'toolbar-item spaced ' + (isActive ? 'active' : '')}
aria-label='Format Painter'>
<i className='format painter' />
</button> */}
export default FormatPainterToolbarButton;
